// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ISensorConfigCommandParams {
	$type?: string | undefined;
}
export class SensorConfigCommandParams {
	constructor(data?: ISensorConfigCommandParams) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	static $type: string = "CoreApi.Models.DeviceCommands.SensorConfigCommandParams, ";
	$type?: string | undefined = SensorConfigCommandParams.$type;
}

